
import {CSSProperties, useCallback} from "react";
import { hooks as metaMaskHooks, metaMask } from 'src/connectors/metaMask';
import { hooks as coinbaseHooks, coinbaseWallet } from 'src/connectors/coinbaseWallet';
// import { hooks as cloverHooks, metaMask as cloverMetaMask } from 'src/connectors/Clover';
import { Connector } from '@web3-react/types'
import {Web3ReactHooks} from "@web3-react/core/dist/hooks";

export const project = require('./project.json');
export const project_dao = require('./project_dao.json');

////////////////////////////////////////////////////////////////////////////////////////
export const erc20 = require('./abi/erc20.json');
export const multicall = require('./abi/multicall.json');
export const exchange = require('./abi/exchange.json');
export const AccountBalance = require('./abi/accountBalance.json');
export const Valut = require('./abi/valut.json');
export const OPMainnetNode = "https://opt-mainnet.g.alchemy.com/v2/nCsMS5baGO99j_PD28OnGC9W2uJjc4-n"
export const MulticallAddress = "0x7C3a48f30B417815302AeD0ef1CEcf1DEa98417f"
export const AccountBalanceAddress = "0xA7f3FC32043757039d5e13d790EE43edBcBa8b7c"
export const ValutAddress = "0xAD7b4C162707E0B2b5f6fdDbD3f8538A5fbA0d60"
export const exchangeAddress = "0xBd7a3B7DbEb096F0B832Cf467B94b091f30C34ec"
export const trader = project.contracts.Proxy.address
export const USDC_Address = "0x7F5c764cBc14f9669B88837ca1490cCa17c31607"
export const USDC_Decimal = 6;
export const USD_Name = "USDC"
export const USD_Decimal = 18;
export const DepositTerm = "14 Days"


////////////////////////////////////////////////////////////////////////////////////////
export const project_bsc_loan = require('./projects_loan/bsc.json');
// export const project_moonbase_loan = require('./projects_loan/moonbase.json');
export const project_clover_loan = require('./projects_loan/clover.json');
export const project_astar_loan = require('./projects_loan/astar.json');

export const precision = 6;
export const maxLoanRate = 0.75;

export const MaxApproveBalance = "1000000000000000000000000000000000";
export const minAllowance = "1000000000000000000000000000000";
export const zeroAddress = "0x0000000000000000000000000000000000000000";

export const settleCoinSymbol = "USD";
export const settleChainCoinSymbol = "USDT";

export type supportWallets =
    "metamask"
    | "Coinbase"
    | "clover";
export const WALLETS: {[key in supportWallets]: IWallet} = {
    metamask: {
        canClick: true,
        name: "MetaMask",
        icon: require("src/assets/images/MetaMask.png"),
        plugin: "isMetaMask",
        iconStyle: {},
        download: "https://metamask.io/download/",
        hooks: metaMaskHooks,
        connector: metaMask
    },
    clover: {
        canClick: false,
        name: "Clover Wallet",
        icon: `require("src/assets/images/clover.png")`,
        plugin: "clover",
        iconStyle: {},
        download: "https://docs.clv.org/use-clv-wallet/download-clv-wallet",
        hooks: metaMaskHooks,
        connector: metaMask
    },
    Coinbase: {
        canClick: true,
        name: "Coinbase Wallet",
        icon: require("src/assets/images/Coinbase.png"),
        plugin: "isCoinbaseWallet",
        iconStyle: {},
        download: "https://www.coinbase.com/wallet/getting-started-extension",
        hooks: coinbaseHooks,
        connector: coinbaseWallet
    }
};
export type IWallet = {
    canClick: boolean,
    name: string,
    icon: string,
    plugin: string,
    iconStyle: CSSProperties,
    download: string,
    hooks: Web3ReactHooks,
    connector: any
};
/*export type IChain = {
    name: string,
    icon: string,
    wallet: IWallet[],
    project: any
}*/
/*type key = "Clover" | "Moonbeam" | "Astar";*/
export enum PROJECT_TYPE {
    project = 'project',
    project_loan = 'project_loan',
    project_dao = 'project_dao'
}
export const CHAINS = {
    BSC: {
        name: "BSC-Test",
        icon: `require("src/assets/images/BSC.png")`,
        wallet: [WALLETS.metamask, WALLETS.clover],
        project: project,
        project_loan: project_bsc_loan,
        project_dao: project_dao,
        browser: "https://testnet.bscscan.com/tx/",
        knownContracts: {
            multicall: "0x8F3273Fb89B075b1645095ABaC6ed17B2d4Bc576"
        }
    },
    Clover: {
        name: "Clover",
        icon: `require("src/assets/images/clover.png")`,
        wallet: [WALLETS.metamask, WALLETS.clover],
        project: project,
        project_loan: project_clover_loan,
        project_dao: project_dao,
        browser: "https://clover-testnet.subscan.io/tx/",
        knownContracts: {
            multicall: "0xA8Db6e2B504Bb043E21f8bDA73b009a4049C5e38"
        }
    },
    Moonbeam: {
        name: "Moonbeam",
        icon: `require("src/assets/images/Moonbeam.png")`,
        wallet: [WALLETS.metamask, WALLETS.clover],
        project: project,
        project_loan: project,
        project_dao: project_dao,
        browser: "https://moonbase.moonscan.io/tx/",
        knownContracts: {
            multicall: "0xbeDadB1312356F817FAc188B8D8385b184Be541b"
        }
    },
    Astar: {
        name: "Astar",
        icon: `require("src/assets/images/Astar.png")`,
        wallet: [WALLETS.metamask, WALLETS.clover],
        project: project,
        project_loan: project_astar_loan,
        project_dao: project_dao,
        browser: "https://shibuya.subscan.io/tx/",
        knownContracts: {
            multicall: "0x8E232581C5a211a2B2A3b4911e5C8a4b0Cf8b212"
        }
    },
    // Parallel: {name: "Parallel", icon: "", wallet: [wallets.polkadot]},
    // Acala: {
    //     name: "Acala",
    //     icon: require("src/assets/images/Alcala.png"),
    //     wallet: [WALLETS.metamask, WALLETS.clover],
    //     project: project_Acala,
    //     project_loan: null,
    //     project_dao: project_dao,
    //     browser: "https://acala-testnet.subscan.io/extrinsic/",
    //     knownContracts: {
    //         multicall: ""
    //     }
    // }
};

export type IChain = typeof CHAINS.BSC;

export function getChainInfo(chainId: number | string): IChain | null  {
    let chainInfo : IChain | null = null;
    let n_chainId = typeof chainId === "string" ? Number(chainId) : chainId;
    Object.values(CHAINS).some((item) => {
        if(item.project.chainid === n_chainId) {
            chainInfo = item;
            return true;
        }
        return false;
    });
    return chainInfo;
}

export function getWalletInfoByName(walletName: string): IWallet | null  {
    let walletInfo : IWallet | null = null;
    Object.values(WALLETS).some((item) => {
        if(item.name === walletName) {
            walletInfo = item;
            return true;
        }
        return false;
    });
    return walletInfo;
}


export type IPairs = "BTC-USD" | "ETH-USD" | "DOT-USD";
export const parisImg: {[key in IPairs]: string} = {
    "BTC-USD": "",
    "ETH-USD": "",
    "DOT-USD": ""
};
